import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Notification List
export const getNotification = createAsyncThunk(
  "getNotification",
  async (
    { search, pageLimit, pageCount, sort_by, date_range },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `notification-list?search=${search}&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&date_range=${date_range}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Status
export const updateNotification = createAsyncThunk(
  "updateNotification",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`notification`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Status
export const updateNotificationAll = createAsyncThunk(
  "updateNotificationAll",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`notification?mark=${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Sale Delete
export const NotificationDelete = createAsyncThunk(
  "NotificationDelete",
  async ({ ids }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`notification`, {
        data: { ids },
      });

      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return rejectWithValue(error.response?.data);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get getNotification
      .addCase(getNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.getNotificationStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getNotification.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = notificationSlice;
export default reducer;
